// import PlanoDeContas from './Index.vue'
import Permissions from "../../models/Permissions";

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

export default [
  {
    path: "/PlanoDeContas",
    name: "Plano de Contas",
    component: () => import("./Index.vue"),
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      showInMenu: true,
      label: "Plano de Contas",
      icon: "fa fa-pie-chart",
      group: "Contabil",
      permissions,
    },
  },
];
